module.exports = {"header":{"portalName":"uMotif ポータル"},"message":{"error":{"default":"エラーが発生しました。","invalidCode":"無効なコードが入力されました。もう一度やり直してください。"}}}